module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nancy Springer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nancy Springer is the award-winning author of more than fifty books, including the Enola Holmes and Rowan Hood series and a plethora of novels for all ages, spanning fantasy, mystery, magic realism, and more. She received the James Tiptree, Jr. Award for "), _c('I', [_vm._v("Larque on the Wing")]), _vm._v(" and the Edgar Award for her juvenile mysteries "), _c('I', [_vm._v("Toughing It ")]), _vm._v("and "), _c('I', [_vm._v("Looking for Jamie Bridger")]), _vm._v(", and she has been nominated for numerous other honors. Springer currently lives in the Florida Panhandle, where she rescues feral cats and enjoys the vibrant wildlife of the wetlands."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OIvJYD/tc-custom/9781497688803.jpg?1705578368752",
      "alt": "This image is the cover for the book Looking for Jamie Bridger"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Looking for Jamie Bridger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Winner of the Edgar Award: A search to find her parents becomes a quest that shakes Jamie Bridger’s identity to its core")]), _c('br'), _c('br'), _vm._v(" Raised by her grandparents, fourteen-year-old Jamie Bridger has never known who her parents are. When she presses for details, her grandmother protests that she doesn’t remember things that happened years ago, and her grandfather reacts by flying into a rage. But who could forget the birth of their only grandchild? And how could a mother give up her baby for good? Shouldn’t Jamie’s parents have tried to get in contact with her?"), _c('br'), _c('br'), _vm._v(" Jamie is determined to find answers, and she’ll go to any lengths to get them, even if it means traveling all the way to New York to find a man who shares her name—a man she believes to be her father. But as she starts to put together the pieces of her past, Jamie learns that the truth is more shocking than anything she could have anticipated.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0